import { graphql, useStaticQuery } from "gatsby"

export const useLocationData = () => {
  const data: any = useStaticQuery(graphql`
    query Location {
      location: allSanityLocation(sort: { name: ASC }) {
        nodes {
          id
          name
          address
          address2
          city
          headOffice
          postal
          province
          license
          image {
            asset {
              gatsbyImageData(formats: [AUTO, WEBP], placeholder: BLURRED)
            }
          }
        }
      }
    }
  `)

  return data
}
